import { render, staticRenderFns } from "./orderdetauk.vue?vue&type=template&id=e0a4694e&scoped=true"
import script from "./orderdetauk.vue?vue&type=script&lang=js"
export * from "./orderdetauk.vue?vue&type=script&lang=js"
import style0 from "./orderdetauk.vue?vue&type=style&index=0&id=e0a4694e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a4694e",
  null
  
)

export default component.exports